var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{on:{"click":_vm.connect}},[_vm._v("Connect")]),_c('b-button',{on:{"click":_vm.launch}},[_vm._v("Launch")]),_c('b-button',{on:{"click":_vm.disconnect}},[_vm._v("Disconnect")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }